module.exports = __webpack_public_path__ + "static/img/gz_ios.0c8cba9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gz_ios.jpg
// module id = i+Wn
// module chunks = 0